import React from 'react';
import { useTranslation } from 'react-i18next';

export default function Hero() {
  const { t } = useTranslation();

  return (
    <section id="hero" className="hero">
      <div className="hero__bg" aria-hidden="true" />
      <div className="hero__content">
        <div className="hero__avatar-wrap">
          <img src="/avatar.jpg" alt={t('hero.name')} className="hero__avatar" />
        </div>
        <p className="hero__greeting">{t('hero.greeting')}</p>
        <h1 className="hero__name">{t('hero.name')}</h1>
        <h2 className="hero__title">{t('hero.title')}</h2>
        <p className="hero__subtitle">{t('hero.subtitle')}</p>
        <div className="hero__ctas">
          <a
            href="https://github.com/eduardo-sepassos"
            target="_blank"
            rel="noopener noreferrer"
            className="btn btn--primary"
          >
            {t('hero.github')}
          </a>
          <a
            href="https://linkedin.com/in/eduardo-passos-438528189"
            target="_blank"
            rel="noopener noreferrer"
            className="btn btn--outline"
          >
            {t('hero.linkedin')}
          </a>
        </div>
      </div>
    </section>
  );
}
